import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useDelete, useNotify } from 'react-admin';
import { convertReactAdminIdToHydraId } from 'utils';

type UseDeleteMerchantNotificationReturnValue = {
  isLoading: boolean;
  deleteMerchantNotification: VoidFunction;
};

export function useDeleteMerchantNotification(
  notificationId: string,
  onSuccess: VoidFunction,
): UseDeleteMerchantNotificationReturnValue {
  const translate = useTypedTranslate();

  const notify = useNotify();
  const [deleteOne, { isLoading }] = useDelete(
    'merchant_notification_settings',
    {
      id: convertReactAdminIdToHydraId(notificationId, 'merchant_notification_settings'),
    },
    {
      onError: (error) => {
        notify(
          `${translate('app.common.error')}: ${error as string}` ||
            translate('app.merchantsShowNotifications.notificationSettingsDeletionError'),
          {
            type: 'error',
          },
        );
      },
      onSuccess: () => {
        onSuccess();
        notify(translate('app.merchantsShowNotifications.notificationSettingsDeleted'), {
          type: 'success',
        });
      },
    },
  );

  return { isLoading, deleteMerchantNotification: deleteOne };
}
